import React from "react";
import { Button, Dialog, DialogActions, DialogTitle } from "@material-ui/core";
import { useTranslations } from "adapters/i18n";

export const DialogExcluir = (props) => {
  const {
    texto,
    modalConfirmacaoExclusao,
    handleFechaModalExclusao,
    handleDelete,
  } = props;
  const { t } = useTranslations();
  return (
    <Dialog
      id="dialogConfirmacaoExclusao"
      open={modalConfirmacaoExclusao}
      aria-labelledby="alert-dialog-title"
      onClose={handleFechaModalExclusao}
    >
      <DialogTitle id="alert-dialog-title">{texto}</DialogTitle>
      <DialogActions>
        <Button
          id="botaoCancelarDialog"
          onClick={handleFechaModalExclusao}
          color="primary"
          autoFocus
          style={{ textTransform: "uppercase" }}
        >
          {t("common:actions.cancel")}
        </Button>
        <Button
          id="botaoExcluirDialog"
          onClick={handleDelete}
          color="primary"
          style={{ textTransform: "uppercase" }}
        >
          {t("common:actions.delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogExcluir;
